import moment from "moment-timezone";
export function AuditModel(item){
    this.id = item.id
    this.referenceCode = item.referenceCode
    this.transactionId = item.transactionId
    this.amount = item.amount
    this.phone = item.phone
    this.time = moment(item.time).format("DD/MM/YYYY HH:mm")
    this.bank = item.bank
    this.stk = item.stk
    this.description = item.description
    this.payments_status = item.payments_status
    this.category_code = item.category_code
    this.category_string = item.category_string
    this.payments_code = item.payments_code
    this.note = item.note
    this.status = item.status
    this.branch_name = item.branch_name
}